import { z } from 'zod';
import { cidrListSchema } from '../general/cidr.ts';
import { reformatCommaList } from './helpers/list.ts';

export const preferredRangesSchema = z.string().transform(reformatCommaList).pipe(cidrListSchema);

export const preferredRangesRequiredSchema = z
  .string()
  .transform(reformatCommaList)
  .pipe(cidrListSchema)
  .refine((val) => val.length !== 0, { message: 'Enter a comma-separated list of CIDR ranges' });
